import { useContext } from 'react';
import { ScreenSizeContext } from '../ScreenSizeProvider';

export const useOverrideScreen = () => {
  const {setOverride} = useContext(ScreenSizeContext);
  return setOverride;
};
